import { HotelCard } from "./HotelCard";

interface HotelResultsProps {
  data: {
    hotels?: Array<{
      id: string;
      name: string;
      stars: number;
      rating: number;
      pricePerNight: number;
      totalPrice: number;
      currency: string;
      address: string;
      imageUrl?: string;
      bookingUrl: string;
    }>;
    count?: number;
    error?: string;
  };
}

export function HotelResults({ data }: HotelResultsProps) {
  if (data.error) {
    return (
      <div className="rounded-lg border border-red-300/35 bg-red-400/10 p-3 text-sm text-red-200">
        Hotel search error: {data.error}
      </div>
    );
  }

  if (!data.hotels?.length) {
    return (
      <div className="rounded-lg border border-white/15 bg-white/5 p-3 text-sm text-ink-light">
        No hotels found for these dates
      </div>
    );
  }

  return (
    <div className="space-y-2 my-2">
      <p className="text-xs text-ink-light font-medium">
        {data.count} hotel{data.count !== 1 ? "s" : ""} found
      </p>
      {data.hotels.map((hotel) => (
        <HotelCard key={hotel.id} hotel={hotel} />
      ))}
    </div>
  );
}
